import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useLang } from '../context/LanguageContext';

const infoIcons = [PhoneIcon, EmailIcon, AccessTimeIcon, LocationOnIcon];

const SectionLabel = ({ children }) => (
  <Box display="flex" alignItems="center" gap={2} mb={2}>
    <Box sx={{ width: 40, height: 3, background: '#C8102E', flexShrink: 0 }} />
    <Typography sx={{
      fontFamily: '"Oswald", sans-serif',
      color: '#C8102E',
      letterSpacing: '0.2em',
      textTransform: 'uppercase',
      fontSize: '0.78rem',
      fontWeight: 500,
    }}>
      {children}
    </Typography>
  </Box>
);

export default function Contact() {
  const { t } = useLang();
  const c = t.contact;

  return (
    <Box id="contact" sx={{ background: '#111111', py: { xs: 7, md: 11 } }}>
      <Container maxWidth="lg">

        {/* Centered header */}
        <Box textAlign="center" mb={{ xs: 6, md: 8 }}>
          <Box display="flex" justifyContent="center">
            <SectionLabel>{c.eyebrow}</SectionLabel>
          </Box>
          <Typography variant="h2" sx={{ color: '#fff', fontSize: { xs: '1.9rem', md: '2.6rem' }, mb: 2, lineHeight: 1.15, whiteSpace: 'pre-line' }}>
            {c.heading}
          </Typography>
          <Typography variant="body1" sx={{ color: '#888', lineHeight: 1.9, fontWeight: 300, fontSize: '0.95rem', maxWidth: 560, mx: 'auto' }}>
            {c.subtext}
          </Typography>
        </Box>

        {/* Info items centered */}
        <Grid container spacing={3} justifyContent="center">
          {c.infoItems.map((item, i) => {
            const Icon = infoIcons[i];
            return (
              <Grid item xs={12} sm={6} md={3} key={item.label}>
                <Box display="flex" flexDirection="column" alignItems="center" textAlign="center" gap={1.5}>
                  <Box sx={{
                    width: 48,
                    height: 48,
                    background: '#C8102E',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <Icon sx={{ color: '#fff', fontSize: 22 }} />
                  </Box>
                  <Box>
                    <Typography sx={{
                      fontFamily: '"Oswald", sans-serif',
                      fontSize: '0.7rem',
                      letterSpacing: '0.15em',
                      textTransform: 'uppercase',
                      color: '#555',
                      mb: 0.3,
                      fontWeight: 500,
                    }}>
                      {item.label}
                    </Typography>
                    <Typography sx={{ color: '#FFFFFF', fontWeight: 500, mb: 0.2, fontSize: '0.92rem' }}>
                      {item.value}
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#555' }}>
                      {item.sub}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>

      </Container>
    </Box>
  );
}
